<template>
    <div class="full-width-edit-material">
        <ul  v-show="viewPart == 'material'" v-loading="loading">
          <li class="region-editor-part" >
            <div class="input-label">
              <span tkey="產品圖片">{{i18n.tkey("lang_product_img")}}</span>
            </div>

            <div>
              <uploadImg  v-model="imgUrl" :width="myUtil.isNotEmpty(imgUrl)? 200 : 400" :height="myUtil.isNotEmpty(imgUrl)?200:400" />
            </div>
          </li>
            <li class="region-editor-part"  v-show="myUtil.isNotEmpty(imgUrl)">
                <itemTypeSelect ref="itemTypeSelectDom"
                @onselectType="chonageType"/>
            </li>


          <div class="region-editor-part" v-show="ishowMaterial" >
          <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="產品名稱(中文)">{{i18n.tkey("lang_product_name_hk")}}</span>
                </div>

                <div>
                    <el-input
                            v-model="productName1"
                            placeholder=""
                            clearable
                            show-word-limit
                            maxlength="75"
                    />
                </div>
            </li>

          <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="產品名稱（英文）">{{i18n.tkey("lang_product_name_en_2")}}</span>
                </div>

                <div>
                    <el-input
                            v-model="productName2"
                            style=""
                            placeholder=""
                            clearable
                            show-word-limit
                            maxlength="75"
                    />
                </div>
            </li>

          <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="產品描述(中文)">{{i18n.tkey("lang_product_description_hk")}}</span>
                </div>

                <div>
                    <el-input
                            v-model="productdescription"
                            style=""
                            placeholder=""
                            clearable
                            show-word-limit
                            maxlength="75"
                    />
                </div>
            </li>

          <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="產品描述(副語言)">{{i18n.tkey("lang_product_description_en_2")}}</span>
                </div>

                <div>
                    <el-input
                            v-model="productdescription2"
                            style=""
                            placeholder=""
                            clearable
                            show-word-limit
                            maxlength="75"
                    />
                </div>
            </li>

          <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="產品銷售價格">{{i18n.tkey("lang_product_cost_2")}}</span>:<span>{{shopCompanyObj.currcode}}</span>
                </div>

                <div>
                    <el-input
                            type="number"
                            v-model="productcost"
                            style=""
                            placeholder=""
                            clearable
                            min="0"
                    />
                </div>
            </li>

            <li v-show="ishowMaterial">
                <div class="input-label">
                    <span tkey="單位">{{i18n.tkey("lang_product_unit")}}</span>
                </div>

                <div>
                    <!--                <el-autocomplete-->
                    <!--                        v-model="productunit"-->
                    <!--                        :fetch-suggestions="querySearch"-->
                    <!--                        clearable-->
                    <!--                        class=""-->
                    <!--                        placeholder=""-->
                    <!--                        @select="handleSelect"-->
                    <!--                />-->

                    <unitCodeSelector ref="unitSelector" v-model="productunit" />
                    <el-button size="large" style="margin-left: 10px" @click="goUnitEditor">...</el-button>
                </div>
            </li>
          </div>

          <li  >
                <el-collapse v-if="null != editObj">
                  <el-collapse-item tkey="eshopop優惠券"  :title="i18n.tkey('lang_discount_coupons')" >
                    <template #title>
                    <div class="custom-title" style="font-size: 16px;">
                      <span tkey="eshopop優惠券">{{i18n.tkey("lang_discount_coupons")}}</span>
                    </div>
                    </template>
                      <div class="region-editor-part" >
                            <couponsMaterialEditor v-model="couponsList" @changeCouponsList="changeCouponsList"  :productObj="editObj" />

                      </div>
                  </el-collapse-item>
                </el-collapse>

            </li>

          <el-collapse v-if="ishowMaterial">
            <el-collapse-item tkey="批發設置"  :title="i18n.tkey('lang_wholesale_setting')" >
              <template #title>
                <div class="custom-title" style="font-size: 16px;">
                  <span tkey="批發設置">{{i18n.tkey("lang_wholesale_setting")}}</span>
                </div>
              </template>
              <li class="region-editor-part" v-if="ishowMaterial">
<!--                <span tkey="批發設置">{{i18n.tkey("lang_wholesale_setting")}}</span>
                <br>-->
                <materialWholesaleEditor v-model="wholesaleList" ref="WholesaleEditorDom" :productObj="editObj" />
              </li>
            </el-collapse-item>
          </el-collapse>



            <li style="text-align: center;padding: 20px;" v-if="ishowMaterial">
                <el-button type="primary" v-if="null == editObj" @click="clickUpload" tkey="上傳產品">{{i18n.tkey("lang_upload_product")}}</el-button>
                <el-button type="primary" v-if="null != editObj" @click="clickUpdate" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
            </li>

        </ul>

        <div v-if="viewPart == 'unit'">
            <unitCodeEditor :showReturnBtn="true" @clickReturnBtn="goMaterialEditor" />
        </div>
    </div>


</template>

<script setup>
import {toRef, ref, onMounted, computed, onUnmounted, onBeforeMount, getCurrentInstance, inject, watch} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import eshopopeeApi from "@/request/eshopopeeApi";
    import itemTypeSelect from "@/components/shopopee/category/itemTypeSelect"
    import uploadImg from "@/components/shopopee/form/uploadImg"
    import unitCodeEditor from "@/components/shopopee/unit/unitCodeEditor"
    import unitCodeSelector from "@/components/shopopee/unit/unitCodeSelector"
    import materialWholesaleEditor from "@/components/shopopee/material/materialWholesaleEditor"
    import myUtil from "@/util/util";
    import materialApi from "@/request/materialApi";
    import companyApi from "@/request/companyApi";
    import CouponsMaterialEditor from "@/components/shopopee/material/couponsMaterialEditor.vue";

    const props = defineProps(['editObj'])
    const emits = defineEmits(['changeMaterial','uploadSuccess', "editSuccess"])

    const { proxy } = getCurrentInstance()

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const loading = ref(false)
    // const restaurants = ref([])
    const ishowMaterial= ref(false)

    const viewPart = ref("material")

    const shopCompanyObj = ref({})

    const unitSelector = ref(null)

    // const querySearch = (queryString, callback) => {
    //     const results = queryString
    //         ? restaurants.value.filter(createFilter(queryString))
    //         : restaurants.value
    //     // call callback function to return suggestions
    //     callback(results)
    // }

    // const createFilter = (queryString) => {
    //     return (restaurant) => {
    //         return (
    //             restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    //         )
    //     }
    // }

    // const loadAll = () => {
    //     return [
    //         { value: '個' },
    //         { value: '盒' },
    //         { value: '箱'},
    //         { value: '臺'},
    //         { value: '斤' },
    //         { value: '升' },
    //         { value: 'pcs' },
    //     ]
    // }

    const handleSelect = (item) => {
        // console.log(item)

    }

    const productName1 = ref("")
    const productName2 = ref("")
    const productdescription = ref("")
    const productdescription2 = ref("")
    const productcost = ref("")
    const productunit = ref("")
    const imgUrl = ref(null)

    //產品的批發價列表
    const wholesaleList = ref([])
    //批發價編輯器dom
    const WholesaleEditorDom = ref(null)

//產品優惠卷
  const couponsList = ref([])


    function clickUpload() {
        checkValue(uploadItem)
    }

    function clickUpdate() {
        checkValue(updateItem)
    }
    function chonageType(){
      ishowMaterial.value=true
    }
    function checkValue(callback) {
        const typeDom = proxy.$refs.itemTypeSelectDom

        const thirdType = typeDom.getThirdType()

        if (null == thirdType){
            myUtil.alertWarning(i18n.tkey("lang_select_product_pls"))
            return
        }

        if (myUtil.isEmpty(productName1.value) || myUtil.isEmpty(productName2.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(productdescription.value) || myUtil.isEmpty(productdescription2.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(productcost.value) || myUtil.isEmpty(productunit.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (typeof callback === "function"){
            callback()
        }
    }
//新增
    function uploadItem(){
        const imgdata = imgUrl.value

        if (myUtil.isEmpty(imgdata)){
            myUtil.alertWarning(i18n.tkey("lang_upload_product_img_pls"))
            return
        }

        const request = eshopopeeApi.uploadProduct
        const params = request.getParams()

        const typeDom = proxy.$refs.itemTypeSelectDom

        const firstType = typeDom.getFirstType()
        const secondType = typeDom.getSecondType()
        const thirdType = typeDom.getThirdType()

        params.type1 = firstType.bcatacode
        params.type2 = secondType.bcatacode
        params.type3 = thirdType.bcatacode
        params.shopopeeCompanyCode = shopCompanyObj.value.companycode
        params.memberID = userInfoRef.value.login
        params.productCompanyCode = shopCompanyObj.value.acccompanycode
        params.productName = productName1.value
        params.productName2 = productName2.value
        params.description = productdescription.value
        params.description2 = productdescription2.value
        params.cost = productcost.value
        params.pt1 = secondType.langhk
        params.pt12 = secondType.langen
        params.pt2 = thirdType.langhk
        params.pt22 = thirdType.langen
        params.unit = productunit.value
        params.curr = shopCompanyObj.value.currcode
        params.imgdata = imgUrl.value

        for (const key in params){
            try {
                params[key] = params[key].replaceAll("'", "''")
            }catch (e) {

            }
        }

        loading.value = true
        request.send(params, uploadCallback)
    }

    function uploadCallback(res) {
        loading.value = false
        console.log(res)
        if (myUtil.isNotEmpty(res)){
            saveWholesaleList(res)

            productName1.value = null
            productName2.value = null
            productdescription.value = null
            productdescription2.value = null
            productcost.value = null
            productunit.value = null
            imgUrl.value = null
            wholesaleList.value = []
            emits("changeMaterial",res)
            myUtil.alertSuccess(i18n.tkey("lang_upload_success"))
        }
    }
//更新
    function updateItem(){
        const imgdata = imgUrl.value

        if (myUtil.isEmpty(imgdata)){
            myUtil.alertWarning(i18n.tkey("lang_upload_product_img_pls"))
            return
        }

        const request = eshopopeeApi.updateProduct
        const params = request.getParams()

        const typeDom = proxy.$refs.itemTypeSelectDom

        const firstType = typeDom.getFirstType()
        const secondType = typeDom.getSecondType()
        const thirdType = typeDom.getThirdType()

        params.CompanyCode = props.editObj.acccode
        params.ProductID = props.editObj.productid
        params.ProductName = productName1.value
        params.productName2 = productName2.value
        params.description = productdescription.value
        params.description2 = productdescription2.value
        params.cost = productcost.value
        params.unit = productunit.value

        if (myUtil.isNotEmpty(imgUrl.value) && imgUrl.value.startsWith("data:")){
            params.imgdata = imgUrl.value
        }

        params.pt1 = secondType.langhk
        params.pt12 = secondType.langen
        params.pt2 = thirdType.langhk
        params.pt22 = thirdType.langen

        for (const key in params){
            try {
                params[key] = params[key].replaceAll("'", "''")
            }catch (e) {

            }
        }

        loading.value = true
        request.send(params, updateCallback)
    }

    function updateCallback(res){
        if(res.code == 200){
            saveWholesaleList(props.editObj.productid)

            const typeDom = proxy.$refs.itemTypeSelectDom

            const secondType = typeDom.getSecondType()
            const thirdType = typeDom.getThirdType()

            const request = materialApi.updateShopItem
            const params = request.getParams()

            params.id = props.editObj.id
            params.productname = productName1.value
            params.productnamecn = productName2.value
            params.description = productdescription.value
            params.description2 = productdescription2.value
            params.cost = productcost.value
            params.unit = productunit.value
            params.bcatacode = secondType.bcatacode
            params.bcatacode2 = thirdType.bcatacode

            request.send(params, (res) => {
                loading.value = false
                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                }else{
                    myUtil.alertError(res.msg)
                }

            })

        }else{
            myUtil.alertError(i18n.tkey("lang_request_error"))
        }
    }

    function goUnitEditor(){
        viewPart.value = "unit"
    }

    function goMaterialEditor(){
        viewPart.value = "material"
        unitSelector.value.reloadOption()
    }

    function fillMaterialInfo(){

      ishowMaterial.value=true
        const typeDom = proxy.$refs.itemTypeSelectDom
        const type2 = props.editObj.bcatacode
        const type3 = props.editObj.bcatacode2
        const type1 = props.editObj.bcatacode.substring(0, 4) + "0000"
        typeDom.setTypeObj(type1, type2, type3)

        productName1.value = props.editObj.productname
        productName2.value = props.editObj.productnamecn
        productdescription.value = props.editObj.description
        productdescription2.value = props.editObj.description2
        productcost.value = props.editObj.cost
        productunit.value = props.editObj.unit
        imgUrl.value = myUtil.generateProductImg(props.editObj)
    }

    function getWholesaleList(){
        loading.value = true

        const request = eshopopeeApi.getMaterialWholesale
        const params = request.getParams()

        params.companycode = shopCompanyObj.value.acccompanycode
        params.productid = props.editObj.productid

        request.send(params, (res) => {
            loading.value = false
            wholesaleList.value = res.detail
        })

    }

    function saveWholesaleList(productid){
        const dataList = wholesaleList.value.concat(WholesaleEditorDom.value.getDelList())

        const request = eshopopeeApi.saveMaterialWholesale
        const params = request.getParams()

        params.productid = productid
        params.companycode = shopCompanyObj.value.acccompanycode
        params.dataList = JSON.stringify(dataList)

        request.send(params, (res) => {

        })
    }

    // onBeforeMount(() => {
    // })


    function getCompanyInfo(){
      loading.value = true
      const request = companyApi.getCompanyInfo
      const params = request.getParams()

      params.companycode = userInfoRef.value.selectCompanycode

      request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
          shopCompanyObj.value = res.detail
          if (null != props.editObj){
            fillMaterialInfo()
            getProductCouPonsList()
          }
          if (null != props.editObj){
            getWholesaleList()
          }
        }
      })

    }
    //當前產品的優惠
  function getProductCouPonsList(){
    loading.value = true
    const request = eshopopeeApi.getProductCouPonsList
    const params = request.getParams()
    params.companycode = shopCompanyObj.value.acccompanycode
    params.PromoProductID = props.editObj.productid
    request.send(params, (res) => {
      loading.value = false
      if (res.code == 200){
        couponsList.value = res.detail
      }
    })

  }

  function changeCouponsList(){
    getProductCouPonsList()

  }


    onMounted(() => {

      getCompanyInfo()


        // restaurants.value = loadAll()
    })
</script>

<style scoped>
    .full-width-edit-material {
        /*width: 100%;*/
        list-style: none;
        padding-left: 15px;
        padding-right: 15px;
        text-align: left;
    }

    .full-width-edit-material li {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }

    .region-editor-part {
        border-radius: 5px;
        box-sizing: border-box;
        border: 1px #E4E7ED solid;
        padding: 20px;
    }
</style>